import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Container } from 'react-bootstrap';
import WindowHeader from '../../../commons/WindowHeader';
import GrupoProveedorTabla from './GrupoProveedorTable';

const GrupoProveedor = (props: any) => {

    const { proveedores } = props;

    const dispatch = useDispatch();


    console.log('App loading');



    return (
        <>
            <WindowHeader title="Proveedores"></WindowHeader>
            <GrupoProveedorTabla proveedores={proveedores}></GrupoProveedorTabla>
        </>
    );
}

export default GrupoProveedor;
